import useSWR from 'swr';
import fetchDataService from '../services/fetchDataService';
import { modules } from '../config/pages';


export function useItems(tokenData:any,itemData:any){
  const {module,company,page,hitsPerPage} = itemData
  const filter = itemData.filter !== undefined 
    ? itemData.filter 
    : (module === modules.RegisterExit)
  const swrKey = page === undefined 
    ? `/inventory/item/get-items${filter ? '/filtered' : ''}` 
    : `/inventory/item/get-items/${page}/${hitsPerPage}${filter ? '/filtered' : ''}`
  const fetcher = () => fetchDataService.post('/inventory/item/get-items',tokenData.key,{...itemData,filter,csrfToken:tokenData?.token.uid})  
  const {data,error,isLoading} = useSWR(()=>(tokenData.key && company)  ? [swrKey,tokenData.token.uid]: null,fetcher,{keepPreviousData:true})
  return {
    data,
    error,
    isLoading
  }
}

export function useMovements(tokenData:any,movementData:any){
  const {first,pending,status,company,documentType,page,hitsPerPage} = movementData
  const url = pending ? '/inventory/movement/get-pending-movements' : first ? '/inventory/movement/get-first-movement' : '/inventory/movement/get-movements'
  const swrKey = page === undefined ? `${url}/${status}/${documentType}` : `${url}/${status}/${documentType}/${page}/${hitsPerPage}`
  const fetcher = () => fetchDataService.post(url,tokenData.key,{...movementData,csrfToken:tokenData?.token.uid})  
  const {data,error,isLoading,mutate} = useSWR(()=>(tokenData.key && company && documentType)  ? [swrKey,tokenData.token.uid]: null,fetcher,{keepPreviousData:true})
  return {
    data,
    error,
    isLoading,
    mutate
  }
}

export function useStoreFetch(tokenData:any,storeData:any){
  const {company,all} = storeData
  const url = '/inventory/storehouse/get-storehouse'
  const swrId = all ? "/bulk" : "/store"
  const fetcher = () => fetchDataService.post(url,tokenData.key,{...storeData,csrfToken:tokenData.token.uid})  
  const {data,error} = useSWR(()=>(tokenData.key && company)  ? [`${url}${swrId}`,tokenData.token.uid]: null,fetcher)
  return {
    data,
    error
  }
}

export function useContactsFetch(tokenData:any,providerData:any){
  const {company,all,role,page,hitsPerPage} = providerData
  const url = '/user/contact/get-contact'
  let swrId = all ? `/bulk/${role}` : "/contact"
  if(page !== undefined && all){
    swrId += `/${page}/${hitsPerPage}`
  }
  const fetcher = () => fetchDataService.post(url,tokenData.key,{...providerData,csrfToken:tokenData.token.uid})  
  const {data,error,isLoading} = useSWR(()=>(tokenData.key && company)  ? [`${url}${swrId}`,tokenData.token.uid]: null,fetcher,{keepPreviousData:true})
  return {
    data,
    error,
    isLoading
  }
}

export function useConfigFetch(tokenData:any,requestData:any){
  const {company} = requestData
  const url = '/security/base/get-module-config'
  const fetcher = () => fetchDataService.post(url,tokenData.key,{...requestData,csrfToken:tokenData.token.uid})  
  const {data,error} = useSWR(()=>(tokenData.key && company)  ? [`${url}`,tokenData.token.uid]: null,fetcher)
  return {
    data,
    error
  }
}

export function useMovementDetail(tokenData:any, requestData:any) {
  const {id} = requestData
  const url = '/inventory/movement/get-movement';
  const fetcher = () => fetchDataService.post(url, tokenData.key, {...requestData, uid: id, csrfToken: tokenData?.token.uid });
  const { data, error, mutate } = useSWR(() => (tokenData.key && id) ? [`${url}/${id}`, tokenData.token.uid] : null, fetcher);
  return {
    data,
    error,
    mutate
  }
}

export function useNotesByReference(tokenData:any, requestData:any) {
  const {referenceId} = requestData
  const url = '/inventory/movement/get-notes-by-reference';
  const fetcher = () => fetchDataService.post(url, tokenData.key, { ...requestData, referenceId, csrfToken: tokenData?.token.uid });
  const { data, error } = useSWR(() => (tokenData.key && referenceId) ? [`${url}/${referenceId}`, tokenData.token.uid] : null, fetcher);
  return {
    data,
    error
  }
}